import { AffiliatesMainStatisticsContainer } from "./AffiliatesMainStatisticsContainer";
import { AffiliatesLinkManagementSection } from "./AffiliatesLinkManagementSection";
import { AffiliatesStatisticsTable } from "../table/AffiliatesStatisticsTable";
import { ISortParams } from "../../../portfolio/interfaces";
import { AffiliatesApiData } from "../interfaces";
import { AffiliatesTitleAndFilterContainer } from "./AffiliatesTitleAndFilterContainer";
import { useMediaQuery } from "@mui/material";
import { AffiliatesLeadCardContainer } from "../leadCard/AffiliatesLeadCardContainer";

export const AffiliatesMainContainer = ({
  sidebarWidth,
  data,
  setSort,
}: {
  sidebarWidth: number;
  data: AffiliatesApiData[];
  setSort: React.Dispatch<React.SetStateAction<ISortParams>>;
}) => {
  const is970px = useMediaQuery("(max-width: 970px)");
  const is720px = useMediaQuery("(max-width: 720px)");

  return (
    <div>
      {is970px && <AffiliatesTitleAndFilterContainer />}
      <AffiliatesMainStatisticsContainer
        sidebarWidth={sidebarWidth}
        data={data}
      />
      {!is720px && <AffiliatesLinkManagementSection />}
      {is720px ? (
        <AffiliatesLeadCardContainer data={data} />
      ) : (
        <AffiliatesStatisticsTable data={data} setSort={setSort} />
      )}
    </div>
  );
};
